import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import { FiberManualRecord } from '@material-ui/icons'
import cn from 'classnames'
import { JOBS_WORKFLOW_ADMIN, JOB_WORKFLOW_TASKS } from 'constants/appRouting'
import * as ROUTE from 'constants/appRouting'
import Column from 'types/table/Column'
import Action from 'types/table/Action'
import ListFromTable from 'components/common/ListFromTable'
import ColumnCollection from 'types/table/ColumnCollection'
import ActionCollection from 'types/table/ActionCollection'
import UrlHelper from 'helpers/url'
import {
  deleteJobInputGroupItem,
  fetchJobInputGroupData,
  jobInputGroupsClearStore,
} from 'reducers/jobInputGroupsAdmin/reducer'
import messages from '../translate'

class JobInputGroupList extends ListFromTable {
  constructor(props) {
    super(props)
    this.asyncData = true
    this.loadingData = true
    this.getTableData = this.getInputGroupsTableData
    this.deleteEntity = props.deleteJobInputGroupItem
    this.clearReducerState = props.jobInputGroupsClearStore

    this.state = {
      isDenseRows: false,
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.loadingData = nextProps.loader

    return super.shouldComponentUpdate(nextProps, nextState)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
      history: { push },
      location: { search },
    } = this.props
    const { isDenseRows } = this.state
    let backUrl = JOBS_WORKFLOW_ADMIN
    let title

    if (search && search.length) {
      const queryParams = new URLSearchParams(search)

      title = `${queryParams.get('jobTitle')} | ${queryParams.get('taskTitle')}`
      backUrl = JOB_WORKFLOW_TASKS
    } else {
      title = formatMessage(messages.jobInputGroupsList)
    }

    return {
      goBack: () => {
        push(backUrl)
      },
      title,
      className: 'job-inputs-table',
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
      dense: {
        enabled: true,
        state: isDenseRows,
        handler: () => this.handleChangeDense(),
      },
    }
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.deleteJobInputGroup),
      message: formatMessage(messages.deleteJobInputGroupMessage),
    }
  }

  getCreateButton() {
    const {
      intl: { formatMessage },
      location: { search },
    } = this.props
    let searchParams

    if (search && search.length) {
      const incomingParams = new URLSearchParams(search)
      const newParams = new URLSearchParams()

      newParams.append('taskId', incomingParams.get('taskId'))
      newParams.append('jobTitle', incomingParams.get('jobTitle'))
      searchParams = newParams.toString()
    }

    return {
      title: formatMessage(messages.createJobInputGroup),
      link: ROUTE.JOB_WORKFLOW_INPUT_GROUPS_CREATE,
      params: searchParams,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()

    columns.add(
      new Column('id', 'ID', {
        sorting: true,
      }),
    )
    columns.add(
      new Column('title', formatMessage(messages.title), {
        sorting: true,
      }),
    )
    columns.add(
      new Column('workflow_title', formatMessage(messages.workflowTitle), {
        sorting: true,
      }),
    )
    columns.add(
      new Column(
        'workflow_task_title',
        formatMessage(messages.workflowTaskTitle),
        {
          sorting: true,
        },
      ),
    )
    columns.add(
      new Column('date_updated', formatMessage(messages.dateUpdated), {
        sorting: true,
        render: ({ date_updated }) => moment(date_updated).format('DD/MM/YYYY'),
      }),
    )
    columns.add(
      new Column('enabled', formatMessage(messages.active), {
        sorting: true,
        render: ({ enabled }) => (
          <FiberManualRecord
            className={cn('user-status-icon', { 'status-enabled': enabled })}
          />
        ),
      }),
    )

    return columns
  }

  getActions() {
    const {
      intl: { formatMessage },
      history,
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action(
        'edit',
        formatMessage(messages.editJobInputGroup),
        ({ id }) => {
          history.push(
            UrlHelper.create(ROUTE.JOB_WORKFLOW_INPUT_GROUPS_EDIT, { id }),
          )
        },
      ),
    )
    actions.add(
      new Action(
        'delete',
        formatMessage(messages.deleteJobInputGroup),
        ({ id }) => {
          this.onOpenConfirmDialog({
            entityId: id,
            psfs: this.psfs,
          })
        },
      ),
    )

    return actions
  }

  getInputGroupsTableData() {
    const {
      fetchJobInputGroupData,
      location: { search },
    } = this.props

    if (search && search.length) {
      const params = new URLSearchParams(search)

      this.psfs.addFilter('task', params.get('taskId'))
    }

    fetchJobInputGroupData({ psfs: this.psfs })
  }

  handleChangeDense() {
    this.setState(prevState => ({
      isDenseRows: !prevState.isDenseRows,
    }))
  }
}

JobInputGroupList.propTypes = {
  tableData: PropTypes.object.isRequired,
  loader: PropTypes.bool.isRequired,
  fetchJobInputGroupData: PropTypes.func,
  deleteJobInputGroupItem: PropTypes.func,
  jobInputGroupsClearStore: PropTypes.func,
}

JobInputGroupList.defaultProps = {
  fetchJobInputGroupData: () => {},
  deleteJobInputGroupItem: () => {},
  jobInputGroupsClearStore: () => {},
}

export default connect(
  state => ({
    tableData: state.getIn(['jobInputGroupsAdmin', 'tableData']),
    loader: state.getIn(['jobInputGroupsAdmin', 'isLoadingTableData']),
  }),
  {
    fetchJobInputGroupData,
    deleteJobInputGroupItem,
    jobInputGroupsClearStore,
  },
)(injectIntl(JobInputGroupList))
